import Swiper from "swiper";
import {MD_WIDTH} from "@main/helpers/const.js";

class StudentSectionSlider {
    constructor(el) {
        this.el = el;

        this.enableSlider();
    }

    enableSlider() {
        new Swiper(this.el, {
            slidesPerView: "auto",
            spaceBetween: 24,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 0,
                }
            }
        });
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-students-section-slider")
        .forEach(slider => new StudentSectionSlider(slider));
});